<template>
  <div class="full-screen-spinner-container">
    <div class="full-screen-spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'FullScreenSpinner',
};
</script>

<style lang="scss" scoped>
.full-screen-spinner-container {
  height: 100vh;
  width: 100vw;
  background-color: white;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;

  .full-screen-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 50px;
    width: 50px;
    transform: translate(-50%, -50%);
    background-image: url('./../../../assets/img/racq-spinner.gif');
    background-size: 100%;
    background-position: center;
  }
}
</style>
